/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { useSelect, useDispatch } from '@wordpress/data';

const divsToUpdate = document.querySelectorAll(".wie-levert-wat-searchbar")

divsToUpdate.forEach(div => {
  const data = JSON.parse(div.querySelector("pre").innerText)
  const root = ReactDOM.createRoot(div)
  root.render(<WieLevertWatSearchbar {...data} />)
  div.classList.remove("wie-levert-wat-data-grid")
});

function WieLevertWatSearchbar(props) {
	const currentSearchTerm = useSelect ((select) => {
		const store =  select('lef-digitaal/wie-levert-wat');
		return store && store.getSearchTerm();
	});
	const actions = useDispatch('lef-digitaal/wie-levert-wat');

	return<>
			<div class="wlw-search">
				<input 
					value={currentSearchTerm} 
					onChange = { (e) => {
						if (actions.updateSearchTerm){
							actions.updateSearchTerm(e.target.value);
						}
					}}
					class="wp-block-search__input has-inter-font-family" 
					placeholder="Zoek.." 
					type="search" 
					style={{borderRadius: 15 + 'rem' , fontWeight: 100 }}
					/>
				<button aria-label="Search" class="button-primary" onClick={() => {
						if (actions.updateSearchTerm){
							actions.updateSearchTerm(currentSearchTerm);
						}
					}}>
					<i class="fa fa-arrow-right"></i>	
				</button>
			</div>
		</>;
}
